module.exports = __webpack_public_path__ + "static/media/croquet-golf-step-1.ea009d41.png";